var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-3 dont-break-across-pages"},[_c('v-alert',{staticClass:"ma-0",attrs:{"dense":"","color":_vm.colour,"colored-border":"","border":"left","icon":_vm.options.icon,"elevation":"2"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.options.html)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }